import { useEffect, useState } from "react";
import { isEmbeddedInHub } from "../suiteSession";
import {
  FX_PWA_INSTALL_DISMISS_KEY,
  readSessionFlag,
  useFacturxPwaInstall,
  writeSessionFlag,
} from "./useFacturxPwaInstall";
import "./pwa.css";

export function FacturxPwaOnboard() {
  const pwa = useFacturxPwaInstall();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [showIos, setShowIos] = useState(false);
  const [showManual, setShowManual] = useState(false);
  const [installDismissed, setInstallDismissed] = useState(() => readSessionFlag(FX_PWA_INSTALL_DISMISS_KEY));

  useEffect(() => {
    if (isEmbeddedInHub() || pwa.isStandalone || !pwa.showInstallUi || readSessionFlag(FX_PWA_INSTALL_DISMISS_KEY)) {
      setOpen(false);
      return;
    }
    setOpen(true);
  }, [pwa.isStandalone, pwa.showInstallUi]);

  if (isEmbeddedInHub()) return null;

  async function handleInstall() {
    if (pwa.canNativeInstall) {
      setBusy(true);
      try {
        await pwa.install();
      } finally {
        setBusy(false);
      }
      return;
    }
    if (pwa.isIos) {
      setShowIos(true);
      setShowManual(false);
      return;
    }
    setShowManual(true);
    setShowIos(false);
  }

  function dismissInstall() {
    writeSessionFlag(FX_PWA_INSTALL_DISMISS_KEY);
    setInstallDismissed(true);
    setOpen(false);
  }

  return (
    <>
      {open ? (
        <div className="fx-pwa-onboard-backdrop" onClick={dismissInstall}>
          <div
            className="fx-pwa-onboard"
            role="dialog"
            aria-labelledby="fx-pwa-install-title"
            onClick={(e) => e.stopPropagation()}
          >
            <img src="./favicon.png" alt="" className="fx-pwa-onboard__icon" />
            <h3 id="fx-pwa-install-title">Installez Aurélia Factures</h3>
            <p>Ouvrez devis et factures depuis l’écran d’accueil, sans repasser par le navigateur.</p>
            <ul>
              <li>Icône sur le bureau ou l’écran d’accueil</li>
              <li>Session Suite conservée</li>
              <li>Même app que dans le hub</li>
            </ul>
            <button type="button" className="fx-pwa-onboard__cta" disabled={busy} onClick={() => void handleInstall()}>
              {busy ? "Installation…" : "Télécharger l’application"}
            </button>
            {showIos ? (
              <ol className="fx-pwa-onboard__steps">
                <li>
                  Appuyez sur <strong>Partager</strong> en bas de Safari
                </li>
                <li>
                  Choisissez <strong>Sur l’écran d’accueil</strong>
                </li>
                <li>
                  Confirmez avec <strong>Ajouter</strong>
                </li>
              </ol>
            ) : null}
            {showManual ? (
              <p className="fx-pwa-onboard__hint">
                Menu du navigateur (⋮) → <strong>Installer l’application</strong> ou{" "}
                <strong>Ajouter à l’écran d’accueil</strong>.
              </p>
            ) : null}
            <button type="button" className="fx-pwa-onboard__later" onClick={dismissInstall}>
              Plus tard
            </button>
          </div>
        </div>
      ) : null}

      {pwa.showInstallUi && installDismissed && !open ? (
        <button type="button" className="fx-pwa-onboard-pill" onClick={() => setOpen(true)}>
          Télécharger l’application
        </button>
      ) : null}
    </>
  );
}
